const DRAFT_PART = "draft";
const CONVERSATION_PREFIX = "conversation:";

function encodePart(part: string): string {
  return encodeURIComponent(part.trim() || "default");
}

export function conversationWorkStoragePart(
  conversationId: string | null | undefined,
): string {
  return conversationId
    ? `${CONVERSATION_PREFIX}${conversationId}`
    : DRAFT_PART;
}

export function buildChatWorkStorageKey(
  kind: "todo-list" | "message-queue" | "drawer-state",
  parts: Array<string | null | undefined>,
): string {
  const scopedParts = parts
    .map((part) => part?.trim())
    .filter((part): part is string => !!part)
    .map(encodePart);
  return `fintheon:${kind}:v2:${scopedParts.join(":") || "default"}`;
}

export function shouldMigrateDraftWorkStorage(
  previousKey: string,
  nextKey: string,
): boolean {
  return (
    previousKey.includes(`:${encodePart(DRAFT_PART)}`) &&
    nextKey.includes(`:${encodePart(CONVERSATION_PREFIX)}`)
  );
}
